(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    const cart = document.querySelector('[data-djh-cart]');
    if (!cart) return;

    cart.querySelectorAll('[data-djh-cart-item]').forEach((row) => {
      const input = row.querySelector('.djh-cart__qty-input');
      const decrement = row.querySelector('[data-djh-qty-decrement]');
      const increment = row.querySelector('[data-djh-qty-increment]');
      if (!input || !decrement || !increment) return;

      // Say the new number. Without this the stepper is silent to anyone not watching
      // it, and 0 — which is how this cart removes a line — is the one worth hearing.
      const qtyStatus = document.querySelector('[data-djh-cart-qty-status]');
      const announce = (next) => {
        if (!qtyStatus) return;
        const label = input.getAttribute('data-djh-qty-label') || '';
        qtyStatus.textContent = label ? label + ': ' + next : String(next);
      };

      decrement.addEventListener('click', () => {
        const next = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
        input.value = String(next);
        announce(next);
      });

      increment.addEventListener('click', () => {
        const next = (parseInt(input.value, 10) || 0) + 1;
        input.value = String(next);
        announce(next);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* THE PINNED OFFSET IS MEASURED, NOT ASSUMED. The utility strip is 31px, 61px or
     150px depending on width (swept on fresh loads 2026-09-22), so a CSS constant is
     wrong at two of the three. This writes the real height into --djh-utility-height,
     which the sticky `top` above reads as a negative offset so the strip scrolls away
     and the nav stays.

     ResizeObserver rather than a resize listener: the strip's height changes when its
     CONTENT reflows, which a window resize event does not always accompany — a font
     swapping in mid-load is the ordinary case, and it is exactly when the number is
     wrong. Observing the element asks the right question.

     No observer and no element both mean the same thing here: leave the variable at
     its 0px default, which pins the whole wrap. That is the safe failure — a header
     slightly taller than intended, never one hanging off the top of the screen. */
  // The nav panel is position:fixed and full-bleed as of 2026-09-23, so it needs the
  // chrome's REAL bottom edge rather than a hardcoded guess. Same observer and the same
  // reason as --djh-utility-height: the strip is 31, 61 or 150px depending on width, so
  // a constant is wrong at two of the three. Also on scroll, because the utility strip
  // scrolls away and the chrome gets shorter.
  const headerRow = document.querySelector('.djh-header');
  if (headerRow && 'ResizeObserver' in window) {
    const setPanelTop = () => {
      const r = headerRow.getBoundingClientRect();
      document.documentElement.style.setProperty('--djh-nav-panel-top', Math.max(0, Math.round(r.bottom)) + 'px');
    };
    setPanelTop();
    new ResizeObserver(setPanelTop).observe(headerRow);
    window.addEventListener('scroll', setPanelTop, { passive: true });
    window.addEventListener('resize', setPanelTop);
  }

  const utility = document.querySelector('.djh-header__utility');
  if (utility && 'ResizeObserver' in window) {
    const setUtilityHeight = () => {
      const h = Math.round(utility.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--djh-utility-height', h + 'px');
    };
    setUtilityHeight();
    new ResizeObserver(setUtilityHeight).observe(utility);
  }

  const toggle = document.querySelector('[data-djh-menu-toggle]');
  const mobileNav = document.querySelector('[data-djh-mobile-nav]');

  if (toggle && mobileNav) {
    // Opening moved focus nowhere and Escape did nothing. Measured 2026-08-21: after
    // clicking the toggle, document.activeElement was still BODY, so a keyboard or
    // screen-reader user had the menu open in front of them and had to tab the whole
    // page to reach it — past every link the menu was covering — with no way to
    // dismiss it short of finding the toggle again.
    //
    // Focus in, Escape out, focus restored. Deliberately NOT a focus trap: this is a
    // navigation drawer, tabbing past the last link reaches the page rather than
    // nothing, and a trap is a bigger mechanism with more ways to strand someone.
    function setOpen(isOpen) {
      mobileNav.classList.toggle('is-open', isOpen);
      mobileNav.hidden = !isOpen;
      toggle.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) {
        const first = mobileNav.querySelector('a[href], button, input, select, textarea');
        // Deferred past this listener on purpose. Clicking a <button> focuses it as
        // part of the browser's default click handling, which runs AFTER this handler,
        // so focusing the first link synchronously here is silently overwritten and
        // focus stays on the toggle.
        //
        // setTimeout rather than requestAnimationFrame, and the difference is not
        // stylistic: rAF DOES NOT FIRE while the page is hidden. That is a documented
        // hazard in this repo — an rAF-based scroll throttle latched for the same
        // reason — and a menu opened by a restored tab or a background render would
        // simply never receive focus, with nothing to show for it. Timers do not care
        // about visibility.
        if (first) setTimeout(() => first.focus(), 0);
      }
    }

    toggle.addEventListener('click', () => setOpen(mobileNav.hidden));

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || mobileNav.hidden) return;
      setOpen(false);
      // Back to the control that opened it, not to the top of the document —
      // otherwise dismissing the menu loses the reader's place entirely.
      toggle.focus();
    });
  }


  // Re-anchor an open panel when the window resizes: the triggers move when the bar
  // reflows, and a stale anchor leaves a panel's links under whatever used to be above
  // them (UX-034's failure — a stale inline position after resize — one property over).
  //
  // Runs synchronously rather than behind a requestAnimationFrame throttle. The first
  // attempt used one, and it could latch: rAF does not fire while the page is hidden, so
  // the "already scheduled" guard stayed set and every later resize returned early. A
  // throttle that can wedge is worse than no throttle for this much work — at most one
  // open panel, two layout reads.
  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-djh-nav-panel].is-open').forEach((panel) => {
      const trigger = panel.previousElementSibling;
      if (trigger) anchorPanelToTrigger(trigger, panel);
    });
  });

  // ── HOVER TO OPEN, LIKE APPLE — added 2026-09-23 on Henry's ask ────────────────────
  //
  // Click was the only way in before this. Hover is what he asked for, and the four
  // things below are what stop it being worse than click rather than better.
  //
  //   INTENT DELAY      a bare mouseenter fires while the pointer is merely CROSSING
  //                     the bar on its way to the cart, so every item it passes flashes
  //                     open. 120ms is long enough to distinguish crossing from aiming
  //                     and short enough to feel instant when you mean it.
  //   CLOSE DELAY       the path from a trigger down into its own panel leaves the
  //                     trigger for a moment. Closing on mouseleave would dismiss the
  //                     panel the user is reaching for. 220ms covers the gap.
  //   SWAP INSTANTLY    once anything is open, moving to another trigger swaps with NO
  //                     delay — that is the seamless slide from Shop to About.
  //   POINTER ONLY      `(hover: hover) and (pointer: fine)`. A touch device reports no
  //                     hover; binding it there gives a phone a menu that opens on the
  //                     first tap and follows the link on the second. Click stays bound
  //                     for everyone, and is the only path on touch.
  //
  // Keyboard is handled by focusin/focusout on the group rather than by hover, so Tab
  // opens a panel and tabbing out of it closes it. Escape closes and returns focus.
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const OPEN_DELAY = 120;
  const CLOSE_DELAY = 220;
  let openTimer = null;
  let closeTimer = null;

  function closeAllPanels(except) {
    document.querySelectorAll('[data-djh-nav-panel].is-open').forEach((openPanel) => {
      if (openPanel === except) return;
      openPanel.classList.remove('is-open');
      const otherTrigger = openPanel.previousElementSibling;
      if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
    });
  }

  // The panel spans the viewport; its CONTENT starts under the trigger that opened it.
  // Clamped against the widest child so a menu near the right edge cannot push its own
  // links off-screen — the panel would still look fine, being full-bleed, and the links
  // would be gone. Mega panels are exempt: Shop uses the whole width by design.
  function anchorPanelToTrigger(trigger, panel) {
    if (!panel || panel.classList.contains('djh-nav__panel--mega')) return;
    const margin = 16;
    // Measure at zero offset: the anchor we are about to compute must not be part of
    // the reading that computes it.
    panel.style.setProperty('--djh-nav-anchor', '0px');
    let content = 0;
    panel.querySelectorAll(':scope > *').forEach((el) => {
      content = Math.max(content, el.getBoundingClientRect().width);
    });
    // The trigger carries 0.6rem of padding as hit area (see the CSS note on target
    // size). Anchoring to its border box would start the links ~10px left of the word
    // they belong to, so the padding is added back — the anchor follows the TEXT.
    const tr = trigger.getBoundingClientRect();
    const padLeft = parseFloat(getComputedStyle(trigger).paddingLeft) || 0;
    const ideal = Math.round(tr.left + padLeft);
    const ceiling = Math.max(margin, Math.round(window.innerWidth - content - margin));
    panel.style.setProperty('--djh-nav-anchor', Math.min(ideal, ceiling) + 'px');
  }

  // WHO OPENED IT decides what a click on the trigger does (SC-1v, 2026-09-24). In Chrome a
  // mouse press focuses the button, `focusin` opens the panel, and the click that follows saw
  // it open and toggled it shut: clicking "Shop" showed nothing, and so did hovering until the
  // panel appeared and then clicking. A click now closes only what a click opened.
  function openPanelFor(trigger, panel, by) {
    closeAllPanels(panel);
    panel.classList.add('is-open');
    panel.dataset.openedBy = by;
    trigger.setAttribute('aria-expanded', 'true');
    anchorPanelToTrigger(trigger, panel);
  }

  function anyPanelOpen() {
    return !!document.querySelector('[data-djh-nav-panel].is-open');
  }

  document.querySelectorAll('[data-djh-nav-trigger]').forEach((trigger) => {
    const panel = trigger.nextElementSibling;
    if (!panel) return;
    const group = trigger.parentElement;

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      const willOpen = !panel.classList.contains('is-open') || panel.dataset.openedBy !== 'click';
      closeAllPanels(panel);
      if (willOpen) {
        openPanelFor(trigger, panel, 'click');
      } else {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    if (canHover && group) {
      group.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        // Already showing something? Swap with no delay — the pointer has committed.
        if (anyPanelOpen()) { openPanelFor(trigger, panel, 'hover'); return; }
        openTimer = setTimeout(() => openPanelFor(trigger, panel, 'hover'), OPEN_DELAY);
      });

      group.addEventListener('mouseleave', () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => closeAllPanels(null), CLOSE_DELAY);
      });
    }

    // The keyboard path, independent of hover.
    if (group) {
      group.addEventListener('focusin', () => {
        clearTimeout(closeTimer);
        if (!panel.classList.contains('is-open')) openPanelFor(trigger, panel, 'focus');
      });
      group.addEventListener('focusout', (event) => {
        if (group.contains(event.relatedTarget)) return;
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !anyPanelOpen()) return;
    const openTrigger = document.querySelector('[data-djh-nav-panel].is-open')?.previousElementSibling;
    closeAllPanels(null);
    if (openTrigger) openTrigger.focus();
  });

  // A CLICK ON THE BLUR CLOSES THE MENU AND DOES NOTHING ELSE (Henry, 2026-09-26). The curtain is
  // pointer-events:none, so a click there used to close the menu AND land on whatever was under
  // it: a product under the blur opened while the customer was only trying to leave the menu.
  // Caught in the capture phase, before the page's own link sees it. A click inside the header
  // (the bar, or the menu band's empty space) is not a click on the blur.
  // Decided at MOUSEDOWN, not at click: pressing on a link under the blur moves focus to it, the
  // keyboard path's focusout then closes the menu, and by the time the click arrives no menu is
  // open and the link is followed. So mousedown blocks the focus move and marks the click to swallow.
  let swallowClick = false;
  document.addEventListener('mousedown', (event) => {
    swallowClick = anyPanelOpen() && !event.target.closest('.djh-header-section');
    if (swallowClick) event.preventDefault();
  }, true);
  document.addEventListener('click', (event) => {
    if (!swallowClick) return;
    swallowClick = false;
    event.preventDefault();
    event.stopPropagation();
    closeAllPanels(null);
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-djh-nav-panel]')) return;
    closeAllPanels(null);
  });

  document.querySelectorAll('[data-djh-mobile-accordion]').forEach((accordion) => {
    accordion.addEventListener('toggle', () => {
      if (!accordion.open) return;
      document.querySelectorAll('[data-djh-mobile-accordion]').forEach((other) => {
        if (other !== accordion) other.open = false;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-djh-product]');
    if (!section) return;

    const priceDisplay = section.querySelector('[data-djh-price-display]');
    const skuLine = section.querySelector('[data-djh-sku]');
    const skuValue = section.querySelector('[data-djh-sku-value]');
    const addButton = section.querySelector('[data-djh-add-to-cart]');
    const form = section.querySelector('.djh-product__form');
    // Both shapes of the single-option control: the radio pills this page used to
    // render, and the <select> that replaced them. Querying only inputs left the new
    // dropdown unbound — the price and the SKU would have stopped following the choice
    // while the form still submitted correctly, which is the kind of half-working that
    // looks fine until somebody checks the price against the variant.
    const variantInputs = section.querySelectorAll(
      '.djh-product__form input[name="id"], .djh-product__form select[name="id"]'
    );
    const optionSelects = section.querySelectorAll('[data-djh-option-select]');
    const variantIdInput = section.querySelector('[data-djh-variant-id]');
    const unavailableNote = section.querySelector('[data-djh-unavailable-note]');
    const chooseNote = section.querySelector('[data-djh-choose-note]');
    const dynamicCheckout = section.querySelector('[data-djh-dynamic-checkout]');
    const mainImage = section.querySelector('[data-djh-main-image]');
    const galleryContainer = section.querySelector('.djh-product__gallery');
    const dynamicThumbsContainer = section.querySelector('[data-djh-dynamic-thumbs]');
    const variantsJson = section.querySelector('[data-djh-product-variants]');
    // THE OPTION NAMES COME FROM MARKUP, NOT FROM LIQUID IN THIS BLOCK.
    //
    // This first interpolated product.options directly here, and a javascript block is
    // NOT Liquid-processed — the braces shipped verbatim, threw
    // "SyntaxError: Unexpected token", and killed this entire script: no price update,
    // no variant switching, no gallery. The page still LOOKED fine, which is how it
    // nearly got past me.
    //
    // Same rule as a stylesheet block, which I had corrected in this theme an hour
    // earlier; Shopify's checker names them together for a reason, in the rule called
    // StaticStylesheetAndJavascriptTags. Anything Liquid must be rendered into the
    // MARKUP and read back from the DOM, which is what data-djh-option-names does.
    //
    // The tag names are spelled out in prose above rather than written as literal tags:
    // the checker reads this comment too, and a literal one here is an error even
    // inside a comment. Writing the warning caused the thing it warns about, twice.
    // Per-variant gram weights, read from MARKUP for the same reason as the option names
    // — this block is not Liquid-processed. Empty object if the attribute is missing or
    // unparseable, which makes the weight row simply stop updating rather than showing
    // another variant's number beside the one on screen.
    const specGrams = (() => {
      const el = section.querySelector('[data-djh-grams]');
      if (!el) return {};
      try {
        return JSON.parse(el.getAttribute('data-djh-grams')) || {};
      } catch (_e) {
        return {};
      }
    })();

    const specOptionNames = (() => {
      const holder = section.querySelector('[data-djh-option-names]');
      if (!holder) return [];
      try {
        return JSON.parse(holder.getAttribute('data-djh-option-names')).map((n) => String(n).trim());
      } catch (_e) {
        return [];
      }
    })();

    const lightbox = section.querySelector('[data-djh-lightbox]');
    const lightboxImage = lightbox && lightbox.querySelector('[data-djh-lightbox-image]');
    const lightboxPrev = lightbox && lightbox.querySelector('[data-djh-lightbox-prev]');
    const lightboxNext = lightbox && lightbox.querySelector('[data-djh-lightbox-next]');
    const lightboxClose = lightbox && lightbox.querySelector('[data-djh-lightbox-close]');

    if (!priceDisplay || !form) return;

    const deliveryNote = section.querySelector('[data-djh-delivery]');
    const variantsById = {};
    // Options-array key (e.g. "14K Yellow Gold___6 X 4 Mm") → variant, for resolving
    // which variant matches the current combination of separate option dropdowns.
    const variantsByOptionKey = {};
    if (variantsJson) {
      try {
        JSON.parse(variantsJson.textContent).forEach((variant) => {
          variantsById[String(variant.id)] = variant;
          if (Array.isArray(variant.options)) {
            variantsByOptionKey[variant.options.join('___')] = variant;
          }
        });
      } catch (_err) {
        /* fall back to data attributes on inputs */
      }
    }

    const addToCartLabel = addButton?.dataset.addLabel || 'Add to cart';
    const ringSizeProp = section.querySelector('[data-djh-ring-size-property]');
    const ringSizeChooseLabel = ringSizeProp ? ringSizeProp.options[0].textContent : '';
    function ringSizeMissing() {
      return !!ringSizeProp && ringSizeProp.value === '';
    }
    const soldOutLabel = addButton?.dataset.soldOutLabel || 'Sold out';

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      // Shopify.formatMoney ships with option_selection.js, which this theme does not
      // load — so this fallback is the path every multi-option product actually takes.
      // toFixed alone dropped the thousands separator and printed $1177.12 where the
      // Liquid `money` filter had server-rendered $1,177.12 (measured 2026-08-19).
      return (
        '$' +
        (Number(cents) / 100).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    }

    // Extra angle photos for the selected variant (djh.gallery_images metafield —
    // Shopify's variant.image is genuinely singular, so this is entirely separate
    // from Shopify's own media system). Rebuilt on every variant change since the
    // set of thumbnails differs per variant.
    function renderDynamicThumbs(meta) {
      if (!dynamicThumbsContainer) return;
      const images = Array.isArray(meta && meta.galleryImages) ? meta.galleryImages : [];
      if (!images.length) {
        dynamicThumbsContainer.hidden = true;
        dynamicThumbsContainer.innerHTML = '';
        return;
      }
      dynamicThumbsContainer.hidden = false;
      dynamicThumbsContainer.innerHTML = images
        .map(function (url, i) {
          const active = i === 0 ? ' is-active' : '';
          // Same semantics as the two Liquid emitters above — see the comment there.
          // A thumbnail rendered by script is no less a control than one rendered by
          // Liquid, and this is the branch that runs on every variant change.
          const label = 'Show product image ' + (i + 1) + ' of ' + images.length;
          return '<img class="djh-product__thumb' + active + '" src="' + url + '" data-djh-thumb data-full-src="' + url + '" loading="lazy" alt="" width="72" height="72" tabindex="0" role="button" aria-label="' + label + '">';
        })
        .join('');
    }

    // Images available to the lightbox for whichever variant is currently selected —
    // kept in sync every time swapImage() runs.
    let currentGalleryImages = [];
    let lightboxIndex = 0;

    // ONLY ANNOUNCE A PRICE SOMEBODY ASKED FOR. syncVariant also runs on load to put
    // the page in a consistent state, and the first version of this let that reach the
    // live region — so a screen reader opened a product page and was read a price it
    // could already see in the page content, before the customer had chosen anything.
    // Caught by asserting the region is EMPTY on load, which is the case I would not
    // have thought to check if I had only tested that announcing works.
    let userChoseVariant = false;

    function updateGalleryImages(meta) {
      if (meta && Array.isArray(meta.galleryImages) && meta.galleryImages.length) {
        currentGalleryImages = meta.galleryImages;
      } else if (meta && meta.featuredImage) {
        currentGalleryImages = [meta.featuredImage];
      } else if (mainImage && mainImage.src) {
        currentGalleryImages = [mainImage.src];
      } else {
        currentGalleryImages = [];
      }
    }

    function swapImage(meta) {
      renderDynamicThumbs(meta);
      updateGalleryImages(meta);
      if (!meta || !meta.featuredImage || !mainImage) return;
      mainImage.src = meta.featuredImage;
      mainImage.srcset = '';
      if (galleryContainer) {
        galleryContainer.querySelectorAll('[data-djh-thumb]').forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.dataset.fullSrc === meta.featuredImage);
        });
      }
    }

    // The inline image/thumbnails use Stuller's $xlarge$ (640x640) — reused as-is in
    // the lightbox that gets upscaled to ~900px, which is what caused the blur. Stuller
    // also serves $zoom$ (1500x1500) specifically for this. No-op for Shopify-hosted
    // URLs (the featuredImage fallback for products without a gallery_images metafield)
    // since those don't contain the token — genuinely capped at 640px in that case.
    function toZoomQuality(url) {
      return url.replace('$xlarge$', '$zoom$');
    }

    function showLightboxImage(index) {
      if (!lightboxImage || !currentGalleryImages.length) return;
      lightboxIndex = (index + currentGalleryImages.length) % currentGalleryImages.length;
      lightboxImage.src = toZoomQuality(currentGalleryImages[lightboxIndex]);
      const multiple = currentGalleryImages.length > 1;
      if (lightboxPrev) lightboxPrev.hidden = !multiple;
      if (lightboxNext) lightboxNext.hidden = !multiple;
    }

    function handleLightboxKeydown(event) {
      // event.key is the standard signal, but fall back to .code / legacy .keyCode —
      // some input paths (assistive tech, certain browser automation) don't always
      // populate .key reliably even though the event itself is genuine.
      const isEscape = event.key === 'Escape' || event.code === 'Escape' || event.keyCode === 27;
      const isLeft = event.key === 'ArrowLeft' || event.code === 'ArrowLeft' || event.keyCode === 37;
      const isRight = event.key === 'ArrowRight' || event.code === 'ArrowRight' || event.keyCode === 39;
      if (isEscape) { closeLightbox(); return; }
      if (isLeft) { showLightboxImage(lightboxIndex - 1); return; }
      if (isRight) { showLightboxImage(lightboxIndex + 1); return; }

      // CONTAIN TAB, BECAUSE THIS DIALOG CLAIMS aria-modal="true".
      //
      // That attribute tells assistive technology the page behind is unavailable,
      // and a screen reader honouring it hides that content — so focus escaping
      // into it lands the user on controls their screen reader has just said do
      // not exist. Escape and the arrow keys already worked; only containment was
      // missing. Same gap, same fix, as the search dialog in djh-search-modal.liquid.
      //
      // The list is recomputed per keypress rather than cached: prev/next are
      // `hidden` on a single-image product and would otherwise be trapped candidates
      // nobody can reach. If nothing is focusable this does nothing and Tab behaves
      // normally — the failure mode is "no trap", never "no way out", and Escape
      // stays bound throughout.
      if (event.key === 'Tab' || event.keyCode === 9) {
        const items = Array.prototype.filter.call(
          lightbox.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'),
          function (el) { return !el.hidden && (el.offsetWidth > 0 || el.offsetHeight > 0); }
        );
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        // Focus starts on the dialog itself (tabindex -1), which is not in `items`: from there Shift+Tab used to leave the
        // dialog backwards. Anything that is not one of the controls counts as outside them, so it is pulled back in.
        const onControl = items.indexOf(document.activeElement) !== -1;
        if (event.shiftKey && (!onControl || document.activeElement === first)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (!onControl || document.activeElement === last)) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    // The zoom must open on the picture that is ON THE PAGE. currentGalleryImages comes from the variant's metafield, but the
    // feed picker swaps the photo (and its thumbnails) itself without a variant sync, so after a stone or metal pick the main
    // picture is not in that list and the old fallback opened index 0: the first variant's picture, a Citrine on an Alexandrite
    // pick (Henry, 2026-11-03). When the list does not hold what is shown, read the page: the visible thumbnails, or just the
    // picture itself.
    function galleryFromPage(shown) {
      const thumbs = Array.from(section.querySelectorAll('[data-djh-thumb]'))
        .filter((t) => !t.closest('[hidden]'))
        .map((t) => t.dataset.fullSrc)
        .filter(Boolean);
      return thumbs.includes(shown) ? thumbs : [shown];
    }

    function openLightbox(startSrc) {
      if (!lightbox) return;
      if (!currentGalleryImages.includes(startSrc)) currentGalleryImages = galleryFromPage(startSrc);
      if (!currentGalleryImages.length) return;
      showLightboxImage(currentGalleryImages.indexOf(startSrc));
      lightbox.hidden = false;
      // Move real focus into the dialog (standard modal a11y practice) — also makes
      // arrow-key handling reliable regardless of where focus happened to be before
      // the image was clicked (images aren't natively focusable, so it could be
      // anywhere: body, a still-focused option select, etc.).
      lightbox.focus();
      document.addEventListener('keydown', handleLightboxKeydown);
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.removeEventListener('keydown', handleLightboxKeydown);
      if (mainImage) mainImage.focus();
    }

    if (mainImage) {
      mainImage.addEventListener('click', () => openLightbox(mainImage.src));
      // The picture opens the viewer, so it has to be reachable and operable without a pointer: a named button that takes
      // Enter and Space. (It is only a button once this script runs; without it, it is just the picture, as before.)
      if (lightbox) {
        mainImage.tabIndex = 0;
        mainImage.setAttribute('role', 'button');
        mainImage.setAttribute('aria-label', lightbox.getAttribute('data-open-label') || mainImage.alt);
        mainImage.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openLightbox(mainImage.src); }
        });
      }
    }
    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', () => showLightboxImage(lightboxIndex - 1));
    }
    if (lightboxNext) {
      lightboxNext.addEventListener('click', () => showLightboxImage(lightboxIndex + 1));
    }
    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }
    if (lightbox) {
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });
    }

    /**
     * WHEN IT SHIPS, for one variant.
     *
     * 🔴 RETURNS null FOR ANYTHING IT DOES NOT RECOGNISE, and the caller hides the line.
     * No default, no fallback, no "made to order" when the field is absent. `Inactive`
     * (32 rows, not orderable) and a null status (11 rows, the vendor said nothing) both
     * render silence, and so does a value nobody has seen before — CATALOG left the field
     * without a `choices` constraint deliberately, because a list that did not match the
     * data refused 407 products in one evening.
     *
     * ⚠️ THE NUMBER COMES FROM THE DATA, NOT FROM A CONSTANT. Henry's wording was "about
     * 8 days" and 8 is the AVERAGE — the real spread is 3 to 42. On a 42-day SKU that
     * sentence is a promise the shop cannot keep and the kind a customer holds you to.
     */
    // The page's two words (djh-variant-json maps Stuller's status onto them): 'ready' | 'made_to_order'; anything else is silence.

    function deliveryLine(meta) {
      if (!deliveryNote || !meta) return null;

      // 🔴 A THING YOU CANNOT BUY HAS NO ARRIVAL DATE. Henry, 2026-09-07, on a natural
      // diamond eternity band: every one of its three metals unavailable, the button
      // reading "Choose a metal", and the page still saying "Arrives in about 3 weeks".
      // The two states came from different fields and nothing joined them, so the promise
      // outlived the ability to keep it.
      //
      // Availability of the SKU at the vendor and orderability on this store are separate
      // facts and both are real: Stuller can call a SKU Made To Order while Shopify shows
      // zero and refuses the sale. When they disagree, the page must follow the one the
      // customer is actually subject to.
      if (meta.available === false) return null;

      const status = String(meta.availability || '').trim().toLowerCase();
      if (!status) return null;

      const known = status === 'ready' || status === 'made_to_order';
      if (!known) return null;

      // 🔴 BOTH BRANCHES READ THE NUMBER. "Ships in 1–2 days" was a fixed string here and
      // D-206 made it wrong: the figure CATALOG projects is Stuller's LeadTime PLUS the
      // shop's 5-day buffer, so an in-stock SKU no longer arrives in 1–2 days. A constant
      // that ignores the field cannot be corrected by the field changing.
      // 🔴 THE QUOTED FIGURE, AND SILENCE WHEN IT IS ABSENT EVEN IF A NUMBER IS RIGHT
      // THERE. `delivery_business_days` can be missing while `lead_time_days` is present
      // — that is what happens when the buffer setting is absent, and the projection
      // deliberately writes NO quoted number rather than +0, because a zero buffer would
      // publish Stuller's dispatch date wearing the shop's field name.
      //
      // This is the one case where the theme has a number available and must still say
      // nothing. It is asserted rather than inferred.
      const businessDays = Number(meta.deliveryDays);
      if (!Number.isFinite(businessDays) || businessDays <= 0) return null;

      // ⚠️ BUSINESS DAYS → CALENDAR WEEKS, and the unit is MEASURED rather than assumed.
      // Integration: every In Stock / Limited / While-supplies-last row carries
      // lead_time_days = 1 — one distinct value across 2,174 rows. A uniform 1 is "next
      // BUSINESS day"; a calendar convention would vary, or show 0 for same-day. The
      // buffer is stated in business days too, so the sum is.
      //
      // 🔴 ceil, NEVER round. D-206: where a unit is ever uncertain, take the reading
      // that makes the promise LONGER. Being conservative costs a sale; being short
      // costs the wedding.
      //
      // Weeks throughout, rather than days-then-weeks. That threshold was mine and
      // invented; five business days IS a week, so one formula covers 1 and 47 alike and
      // there is no seam for a boundary bug to live in.
      const weeks = Math.ceil(businessDays / 5);

      // "about 1 weeks" is what a naive plural produces, and it is the sort of thing that
      // tells a customer a machine wrote the page.
      const phrase = weeks === 1
        ? (deliveryNote.dataset.week || '')
        : (deliveryNote.dataset.weeks || '').replace('__N__', String(weeks));

      // "Made for you" is the only difference between the two states. The duration is the
      // same sentence either way, because it is the same measurement.
      return status === 'made_to_order'
        ? (deliveryNote.dataset.made || '').replace('__PHRASE__', phrase)
        : (deliveryNote.dataset.stocked || '').replace('__PHRASE__', phrase);
    }

    /**
     * Before a full selection, the honest answer is the SPREAD, not one variant's figure.
     * On a 2,023-variant band, quoting 1 day for something that takes 40 is the
     * difference between an honest page and a false one.
     */
    function deliveryRange() {
      if (!deliveryNote) return null;
      let lo = null;
      let hi = null;
      Object.keys(variantsById).forEach((id) => {
        // Same rule as the single-variant line, and it has to be here too: the spread is
        // what a customer sees BEFORE choosing, so a range built from variants they
        // cannot buy is the same false promise arriving one step earlier.
        if (variantsById[id].available === false) return;
        const days = Number(variantsById[id].deliveryDays);
        if (!Number.isFinite(days) || days <= 0) return;
        if (lo === null || days < lo) lo = days;
        if (hi === null || days > hi) hi = days;
      });
      if (lo === null) return null;
      // `available: true` stated rather than omitted: every variant reaching this point
      // has already passed the filter above, and leaving the key out would make the call
      // depend on `undefined === false` being false — true today, and the sort of thing
      // that changes when someone tightens the check.
      if (lo === hi) return deliveryLine({ availability: 'ready', deliveryDays: lo, available: true });
      // Both ends converted the same way as a single figure, so the range and the
      // exact answer a customer sees after choosing are in the same unit.
      // Both ends through the same formula as a single figure, so the range and the
      // exact answer after choosing are in the same unit and cannot disagree.
      return (deliveryNote.dataset.range || '')
        .replace('__MIN__', String(Math.ceil(lo / 5)))
        .replace('__MAX__', String(Math.ceil(hi / 5)));
    }

    function paintDelivery(meta) {
      if (!deliveryNote) return;
      const text = meta ? deliveryLine(meta) : deliveryRange();
      deliveryNote.textContent = text || '';
      deliveryNote.hidden = !text;
    }

    function syncVariant(variantId) {
      const meta = variantsById[variantId];
      paintDelivery(meta);
      const selectedInput = form.querySelector('input[name="id"]:checked');
      const formatted =
        (selectedInput && selectedInput.dataset.djhVariantPrice) ||
        (meta ? formatMoney(meta.price) : null);

      if (formatted) {
        priceDisplay.textContent = formatted;
      }

      // THE SAME RULE THE SERVER APPLIED, APPLIED AGAIN ON SELECTION. The markup only
      // renders this line when the arriving variant's SKU is a real one, so a switch
      // to a variant whose SKU is the URL handle would otherwise write the artefact
      // back into a line the server had already judged. No product on dev mixes the
      // two today; this costs three lines and removes the way it could start.
      if (skuLine && skuValue && meta && meta.sku && !skuLine.hasAttribute('data-djh-style')) {
        const artefact = meta.sku === skuLine.dataset.djhHandle;
        skuLine.hidden = artefact;
        if (!artefact) skuValue.textContent = meta.sku;
      }

      // THE SPEC PANEL'S OPTION ROWS MUST FOLLOW THE SELECTION. Thickness and Length
      // are rendered server-side from the variant the customer ARRIVED on; without
      // this they would keep showing 1.0 mm / 16 in while the price and SKU moved
      // beneath them — a spec table that quietly disagrees with the thing being
      // bought, which is worse than not having one.
      //
      // Matched by the <dt> TEXT against the option name, not by row index: the
      // snippet drops empty rows, so an index would shift on any product missing a
      // metafield and silently rewrite the wrong row.
      // THE WEIGHT ROW FOLLOWS THE VARIANT TOO. It is not an option, so the name-matching
      // below cannot carry it: on this chain 1.0 mm/16 in is 2.71 g and 1.5 mm/16 in is
      // 2.84 g, and a stale gram figure beside a changed price is a number a customer
      // would hold us to.
      if (Object.keys(specGrams).length) {
        const panel = section.querySelector('.djh-spec');
        const g = specGrams[String(variantId)];
        if (panel) {
          panel.querySelectorAll('dt').forEach((dt) => {
            if (!/^Weight\b/.test(dt.textContent.trim())) return;
            const dd = dt.nextElementSibling;
            if (dd && g) dd.textContent = g + ' g';
          });
        }
      }

      if (meta && Array.isArray(meta.options) && specOptionNames.length) {
        const panel = section.querySelector('.djh-spec');
        if (panel) {
          const terms = panel.querySelectorAll('dt');
          terms.forEach((dt) => {
            const i = specOptionNames.indexOf(dt.textContent.trim());
            if (i === -1) return;
            const dd = dt.nextElementSibling;
            if (dd && meta.options[i] != null) dd.textContent = meta.options[i];
          });
        }
      }

      // "START WITH THIS DESIGN" FOLLOWS THE SELECTION. The link is rendered for the variant the customer arrived on; without this it kept
      // that variant's size, width and length however they chose afterwards (found on a Width x Length pendant, true of a bracelet's size too).
      const commissionLink = section.querySelector('[data-djh-commission-link]');
      if (commissionLink && meta && Array.isArray(meta.options) && specOptionNames.length) {
        try {
          const u = new URL(commissionLink.getAttribute('href'), window.location.origin);
          u.searchParams.set('variant', String(variantId));
          const piece = u.searchParams.get('piece');
          specOptionNames.forEach((n, i) => {
            const v = meta.options[i];
            if (v == null) return;
            if (n === 'Width') u.searchParams.set('width', String(v).replace(/\s*mm$/i, '').trim());
            else if (n === 'Length') u.searchParams.set('pendant_length', String(v).replace(/\s*in$/i, '').trim());
            else if (/size/i.test(n) && piece === 'bracelet') u.searchParams.set('length', String(v));
            else if (/size/i.test(n) && piece === 'ring') u.searchParams.set('ring_size', String(v));
          });
          commissionLink.setAttribute('href', u.pathname + u.search);
        } catch (_e) { /* a link the browser cannot parse is left as rendered */ }
      }

      // The Customize snippet holds a pendant's name to the selected length.
      if (meta && Array.isArray(meta.options)) {
        section.dispatchEvent(new CustomEvent('djh:variant-change', { detail: { options: meta.options, names: specOptionNames } }));
      }

      if (addButton) {
        const available = meta ? meta.available : !(input && input.disabled);
        // D-277 slice 3: a required size sent as a line property holds the button until it is chosen.
        const sizeMissing = ringSizeMissing();
        addButton.disabled = !available || sizeMissing;
        addButton.textContent = !available ? soldOutLabel : sizeMissing ? ringSizeChooseLabel : addToCartLabel;
      }

      // SAY WHAT CHANGED. The block above rewrites the price, the SKU and the button
      // label when a size or metal is picked. A sighted customer watches the number
      // change; a screen reader user heard nothing at all, on the one fact that decides
      // whether they buy. Price and availability go together, because a swap can change
      // either and hearing one without the other is worse than silence.
      const variantStatus = section.querySelector('[data-djh-variant-status]');
      if (variantStatus && formatted && userChoseVariant) {
        const availableNow = meta ? meta.available : !(input && input.disabled);
        variantStatus.textContent = formatted + (availableNow ? '' : ' \u2014 ' + soldOutLabel);
        clearTimeout(variantStatus._djhClear);
        variantStatus._djhClear = setTimeout(() => { variantStatus.textContent = ''; }, 4000);
      }

      // A size has now been chosen, so the prompt goes and Buy It Now appears.
      // Both are no-ops on every product that was not asking for a choice.
      if (chooseNote) chooseNote.hidden = true;
      // Buy It Now skips the cart, so it stays hidden while a required size is unchosen: it would buy an unsized ring.
      if (dynamicCheckout) dynamicCheckout.hidden = ringSizeMissing();

      swapImage(meta);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    // Separate-control-per-option path (2-3 options: Metal, Stone Size, ...).
    //
    // A control here is a <select> OR a radio group — metal is drawn as swatches, because
    // it is the one option a customer chooses by eye. Both carry data-option-position and
    // both bubble `change`, so only the VALUE read differs; the listener below and the
    // resolver are untouched.
    const optionValue = (control) => {
      if (control.tagName === 'SELECT') return control.value;
      const checked = control.querySelector('input:checked');
      return checked ? checked.value : '';
    };

    /**
     * Set one option control, whichever kind it is.
     *
     * Mirrors optionValue() above: a metal axis is a swatch row of radios, everything
     * else is a <select>, and the resolver must be able to drive both.
     */
    const setOptionValue = (control, value) => {
      if (control.tagName === 'SELECT') {
        control.value = value;
        return;
      }
      const input = control.querySelector('input[value="' + (window.CSS && CSS.escape ? CSS.escape(value) : value) + '"]');
      if (input) input.checked = true;
    };

    /**
     * The option VALUE's id, which is what `?option_values=` takes (D-146).
     *
     * Mirrors optionValue() exactly — a metal axis is a row of radios, everything else
     * is a select — and returns '' rather than undefined so one missing id disqualifies
     * the whole lookup instead of producing a URL with a hole in it.
     */
    const optionOvid = (control) => {
      if (control.tagName === 'SELECT') {
        const chosen = control.options[control.selectedIndex];
        return (chosen && chosen.dataset.djhOvid) || '';
      }
      const checked = control.querySelector('input:checked');
      return (checked && checked.dataset.djhOvid) || '';
    };

    /** Repaint every axis's "chosen" label and swatch ring, not only the one touched. */
    const paintOptionLabels = () => {
      optionSelects.forEach((control) => {
        const pos = control.dataset.optionPosition;
        const label = section.querySelector('[data-djh-option-chosen="' + pos + '"]');
        if (label) label.textContent = optionValue(control);
        control.querySelectorAll('.djh-product__swatch').forEach((sw) => {
          sw.classList.toggle('is-selected', sw.querySelector('input').checked);
        });
      });
    };

    /**
     * 🔴 THE OPTIONS ON A STULLER RING ARE NOT INDEPENDENT, AND THE FORM OFFERS THEM AS
     * IF THEY WERE. Measured on 127038: 2 metals x 6 stone sizes x 3 shapes is 36
     * combinations and SIXTEEN variants exist, because size is bound to shape —
     *
     *     Round    6.5 · 7.4 · 8 mm
     *     Oval     8x6 · 9x7 · 10x8 mm
     *     Emerald  8x6 · 9x7 mm
     *
     * So choosing Round while the size says 8x6 asks for a ring that was never made. The
     * old behaviour was to resolve nothing and return, which left the PREVIOUS variant on
     * screen: the shape dropdown read "Round" above a photograph of an Oval, at the
     * Oval's price. Henry reported it as lost images. Nothing is lost — all 16 variants
     * carry their own picture — the page simply never moved.
     *
     * A dead end is the wrong answer to "show me the round one". This honours the axis
     * the customer just touched and moves the others to meet it, which is what changing
     * a shape MEANS. Their remaining choices are preserved wherever a variant allows:
     * pick Round on a Yellow ring and you get a Yellow Round, not a White one.
     */
    function snapToChangedOption(changed) {
      const pos = Number(changed.dataset.optionPosition);
      const wanted = optionValue(changed);
      if (!wanted || Number.isNaN(pos)) return null;

      const ordered = Array.from(optionSelects).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition),
      );
      const current = ordered.map(optionValue);

      let best = null;
      let bestScore = -1;
      Object.keys(variantsById).forEach((id) => {
        const v = variantsById[id];
        if (!Array.isArray(v.options) || v.options[pos] !== wanted) return;
        // Keep as much of what they already chose as possible, and prefer something they
        // can actually buy — an in-stock match beats a closer one they cannot order.
        let score = v.options.reduce(
          (n, value, i) => n + (i !== pos && value === current[i] ? 1 : 0),
          0,
        );
        if (v.available !== false) score += 100;
        if (score > bestScore) {
          bestScore = score;
          best = v;
        }
      });
      return best;
    }

    /**
     * 🔴 THE MAP ON THIS PAGE HOLDS 250 VARIANTS AND THE PRODUCT SELLS 811 (D-146).
     *
     * Liquid caps `product.variants` at 250. Measured on /products/…-dmgr, 2026-09-08:
     * the array carries 250 of the 811 published variants, and the option dropdowns —
     * built from `options_with_values`, which is NOT capped — offer all 13 metals, all
     * 7 widths and all 24 sizes. So the controls invite combinations the map has never
     * heard of, and only 51 of the (metal, width) pairs are inside the window.
     *
     * What made this expensive to see is that it does not look like an error. A miss
     * fell through to snapToChangedOption(), which honours the axis just touched and
     * MOVES THE OTHERS to something it can find — correct behaviour for 127038, where
     * the axes genuinely are not independent, and silently wrong here, where they are.
     * A customer asking for Platinum / 8 mm / 11 was shown a different metal at a
     * different price, with nothing on screen saying so.
     *
     * The server has always been right. Both `?option_values=` and `?variant=` resolve
     * past the window — 18K White / 8 Mm / 4 answers 56137742909762 at $2,908.98, and
     * that id appears nowhere in the array. So this asks the server the question the
     * map cannot answer, and merges the reply.
     *
     * ⚠️ ORDER MATTERS AND IT IS LOCAL FIRST. A hit in the map is instant and costs
     * nothing; the fetch happens only on a miss, and only on a capped product. Below
     * 250 the array is complete, a miss means the combination does not exist, and the
     * snap runs immediately exactly as it always has.
     *
     * ⚠️ AND "NO VARIANT" IS AN ANSWER, NOT A FAILURE. The server renders no selected
     * variant for a combination that was never made (18K Yellow / 6 Mm / 4, probed the
     * same afternoon). That falls through to the snap, which is the designed behaviour.
     * A NETWORK failure does not: it leaves the choice alone and disables the button,
     * because moving somebody's selection on the strength of a request that never
     * arrived is the one outcome worse than saying nothing.
     */
    const productUrl = section.dataset.djhProductUrl || '';
    const sectionId = section.dataset.djhSectionId || '';
    const variantsCapped = section.dataset.djhVariantsCapped === 'true';
    let remoteToken = 0;

    function mergeVariant(v) {
      if (!v || v.id === undefined || v.id === null) return null;
      variantsById[String(v.id)] = v;
      if (Array.isArray(v.options)) variantsByOptionKey[v.options.join('___')] = v;
      return v;
    }

    /** Take the resolved variant: clear the note, point the form at it, redraw. */
    function applyResolved(meta) {
      if (unavailableNote) unavailableNote.hidden = true;
      if (variantIdInput) variantIdInput.value = meta.id;
      syncVariant(String(meta.id));
      refreshChoices();
    }

    /**
     * D-277: SHOW ONLY WHAT CAN BE MADE, AND SAY WHAT A PICK CHANGED (Henry, 2026-09-27, taking CATALOG's
     * recommendation; 124 of 195 multi-option products have combinations that don't exist).
     *
     * Read from THIS product's variants, never a family rule. The axes are hierarchical, the way Brilliant Earth
     * and Blue Nile behave: an axis offers only the values that exist with the choices made on the axes ABOVE it,
     * so the top axis always offers everything and nothing is ever unreachable. An unchosen axis (a ring size not
     * yet picked) constrains nothing.
     *
     * ⚠️ "ABOVE" IS BY WHAT THE CHOICE IS, NOT BY THE PRODUCT'S OPTION ORDER. Stuller lists Stone Size before Stone
     * Shape, and ranking by position hid Round on the zircon ring 71620 until a 6 mm size was picked, measured on
     * the bench 2026-09-27: the customer who wants a round stone was never offered one. People choose metal, then
     * the stone, then its shape, then the rest; the ring size is last. So a shape narrows the sizes, never the
     * reverse, and picking Round moves the size and says so.
     *
     * ⚠️ ONLY WHERE THE MAP IS COMPLETE. On a capped product (250+ variants, D-146) the page holds a window of the
     * variants, and "not in the window" is not "cannot be made", so nothing is hidden and no "+$" is guessed.
     */
    const forcedNote = section.querySelector('[data-djh-option-forced]');

    function orderedOptionControls() {
      return Array.from(optionSelects).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition),
      );
    }

    /** Whole dollars when the difference is whole, so a "+$400" never reads "+$400.00". */
    function formatDelta(cents) {
      const dollars = Math.abs(Number(cents) / 100);
      return (Number(cents) < 0 ? '\u2212$' : '+$') + dollars.toLocaleString('en-US', {
        minimumFractionDigits: Number.isInteger(dollars) ? 0 : 2,
        maximumFractionDigits: 2,
      });
    }

    const CHOICE_RANK = { metal: 0, 'stone type': 1, 'stone shape': 2, 'center stone shape': 2, 'ring size': 9, 'finger size': 9 };
    const rankOf = (i) => {
      const r = CHOICE_RANK[String(specOptionNames[i] || '').toLowerCase()];
      return (r === undefined ? 5 : r) * 10 + i; // ties keep the product's own order
    };

    function refreshChoices() {
      if (variantsCapped) return;
      const ordered = orderedOptionControls();
      const selected = ordered.map(optionValue);
      const variants = Object.keys(variantsById).map((id) => variantsById[id]);
      const complete = selected.every((v) => v !== '');
      const currentMeta = complete ? variantsByOptionKey[selected.join('___')] : null;

      ordered.forEach((control, i) => {
        if (control.hasAttribute('hidden')) return; // a fact: one value, nothing to offer
        const exists = (value) =>
          variants.some(
            (v) =>
              Array.isArray(v.options) &&
              v.options[i] === value &&
              v.options.every((o, j) => j === i || rankOf(j) > rankOf(i) || selected[j] === '' || o === selected[j]),
          );
        // The "+$" is what clicking will actually cost: the exact combination when it exists, otherwise the variant
        // the snap would move to (same scoring as snapToChangedOption), so Round on 71620 reads "+$180" before it is
        // clicked rather than nothing, and never a figure for a ring that isn't made.
        const deltaFor = (value) => {
          if (!currentMeta || value === selected[i]) return '';
          let other = variantsByOptionKey[selected.map((s, j) => (j === i ? value : s)).join('___')];
          if (!other) {
            let bestScore = -1;
            variants.forEach((v) => {
              if (!Array.isArray(v.options) || v.options[i] !== value) return;
              let score = v.options.reduce((n, o, j) => n + (j !== i && o === selected[j] ? 1 : 0), 0);
              if (v.available !== false) score += 100;
              if (score > bestScore) {
                bestScore = score;
                other = v;
              }
            });
          }
          const diff = other ? Number(other.price) - Number(currentMeta.price) : 0;
          return diff !== 0 ? formatDelta(diff) : '';
        };

        if (control.tagName === 'SELECT') {
          Array.from(control.options).forEach((opt) => {
            if (opt.value === '') return; // the "choose a size" prompt
            if (opt.dataset.djhBase === undefined) opt.dataset.djhBase = opt.textContent;
            const ok = opt.value === selected[i] || exists(opt.value);
            opt.hidden = !ok;
            opt.disabled = !ok;
            const delta = ok ? deltaFor(opt.value) : '';
            opt.textContent = opt.dataset.djhBase + (delta ? ' (' + delta + ')' : '');
          });
          return;
        }
        control.querySelectorAll('input[type="radio"]').forEach((input) => {
          const holder = input.closest('label');
          if (!holder) return;
          const ok = input.checked || exists(input.value);
          holder.hidden = !ok;
          const deltaEl = holder.querySelector('[data-djh-option-delta]');
          if (deltaEl) deltaEl.textContent = ok ? deltaFor(input.value) : '';
        });
      });
    }

    /** The sentence for a snap: which other choices moved, and why. Empty when none did. */
    function forcedSentence(before, after, changedPos, wanted) {
      const parts = [];
      after.forEach((value, i) => {
        if (i === changedPos || before[i] === '' || before[i] === value) return;
        const name = specOptionNames[i] || 'Option';
        parts.push(name + ' changed to ' + value + ': ' + wanted + ' doesn’t come in ' + before[i] + '.');
      });
      return parts.join(' ');
    }

    /** Nothing matches: honour the touched axis if we can, otherwise say so. */
    function snapOrGiveUp(ordered, changed) {
      const snapped = changed ? snapToChangedOption(changed) : null;
      if (snapped) {
        const before = ordered.map(optionValue);
        ordered.forEach((control, i) => setOptionValue(control, snapped.options[i]));
        paintOptionLabels();
        applyResolved(snapped);
        // Said, not done silently: on 127038 picking Round moved the size AND the price, and the page never said so.
        if (forcedNote) {
          forcedNote.textContent = forcedSentence(
            before,
            snapped.options,
            Number(changed.dataset.optionPosition),
            optionValue(changed),
          );
        }
        return;
      }
      if (unavailableNote) unavailableNote.hidden = false;
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = soldOutLabel;
      }
    }

    function syncFromOptionSelects(changed) {
      const ordered = Array.from(optionSelects).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition),
      );
      // A RING SIZE STILL UNCHOSEN (Henry, 2026-09-24). Changing the metal must not snap
      // the size to whatever variant fits — that is the preselection this replaced, one
      // click later. Until every axis has a value, nothing can be bought.
      if (ordered.some((control) => optionValue(control) === '')) {
        remoteToken += 1;
        if (variantIdInput) variantIdInput.value = '';
        if (unavailableNote) unavailableNote.hidden = true;
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.chooseLabel || addButton.textContent;
        }
        const dynamicCheckout = section.querySelector('[data-djh-dynamic-checkout]');
        if (dynamicCheckout) dynamicCheckout.hidden = true;
        refreshChoices();
        return;
      }
      const key = ordered.map(optionValue).join('___');
      const meta = variantsByOptionKey[key];

      if (meta) {
        remoteToken += 1; // any reply still in flight is now about a stale choice
        applyResolved(meta);
        return;
      }

      const ids = ordered.map(optionOvid);
      const askable =
        variantsCapped && productUrl && sectionId && ids.length && ids.every(Boolean);
      if (!askable) {
        snapOrGiveUp(ordered, changed);
        return;
      }

      const token = (remoteToken += 1);
      // No note yet — we do not know. Saying "unavailable" and taking it back is worse
      // than a button that is briefly not pressable.
      if (unavailableNote) unavailableNote.hidden = true;
      if (addButton) addButton.disabled = true;

      fetch(
        productUrl +
          '?option_values=' +
          ids.map(encodeURIComponent).join(',') +
          '&section_id=' +
          encodeURIComponent(sectionId),
        { headers: { Accept: 'text/html' } },
      )
        .then((res) => (res.ok ? res.text() : Promise.reject(new Error(String(res.status)))))
        .then((html) => {
          if (token !== remoteToken) return; // the customer has chosen again since
          const doc = new DOMParser().parseFromString(html, 'text/html');

          // The weight travels with the variant. A gram figure from the previous size
          // beside this one's price is a number a customer would hold us to.
          const gramsEl = doc.querySelector('[data-djh-grams]');
          if (gramsEl) {
            try {
              Object.assign(specGrams, JSON.parse(gramsEl.getAttribute('data-djh-grams')) || {});
            } catch (_e) {
              /* keep what we have; the row simply does not move */
            }
          }

          let resolved = null;
          const blob = doc.querySelector('[data-djh-selected-variant]');
          if (blob) {
            try {
              resolved = mergeVariant(JSON.parse(blob.textContent));
            } catch (_e) {
              resolved = null;
            }
          }

          if (resolved) {
            applyResolved(resolved);
          } else {
            // The server says this combination was never made. That is the 127038 case
            // and the snap is the right answer to it.
            snapOrGiveUp(ordered, changed);
          }
        })
        .catch(() => {
          if (token !== remoteToken) return;
          // NOT a snap. We never heard back, so we do not know whether this exists, and
          // silently rewriting the customer's choice on no information is the worse of
          // the two wrong answers.
          if (unavailableNote) unavailableNote.hidden = false;
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = soldOutLabel;
          }
        });
    }

    /**
     * D-277 on the one-option path: the chips are variants, so the chosen name and the "+$" on the others come from
     * the checked radio. The delta is against the stone already chosen, and nothing is said before one is.
     */
    const variantChips = section.querySelector('[data-djh-variant-chips]');
    function refreshVariantChips() {
      if (!variantChips) return;
      const checked = variantChips.querySelector('input:checked');
      const chosen = section.querySelector('[data-djh-option-chosen="single"]');
      if (chosen) chosen.textContent = checked ? checked.dataset.djhOptionName : '';
      const base = checked ? Number(checked.dataset.djhVariantCents) : null;
      variantChips.querySelectorAll('input[type="radio"]').forEach((input) => {
        const deltaEl = input.closest('label').querySelector('[data-djh-option-delta]');
        if (!deltaEl) return;
        const diff = base === null || input.checked ? 0 : Number(input.dataset.djhVariantCents) - base;
        deltaEl.textContent = diff !== 0 ? formatDelta(diff) : '';
      });
    }

    variantInputs.forEach((input) => {
      input.addEventListener('change', () => {
        userChoseVariant = true;
        syncVariant(input.value);
        refreshVariantChips();
      });
    });
    refreshVariantChips();

    // Choosing the size re-runs the variant sync, which releases the button and Buy It Now if the variant is buyable.
    if (ringSizeProp) {
      ringSizeProp.addEventListener('change', () => {
        const id =
          (form.querySelector('input[name="id"]:checked') || {}).value ||
          (form.querySelector('select[name="id"]') || {}).value ||
          (variantIdInput && variantIdInput.value);
        if (id) syncVariant(String(id));
      });
    }

    optionSelects.forEach((control) => {
      control.addEventListener('change', () => {
        userChoseVariant = true;
        if (forcedNote) forcedNote.textContent = ''; // a new pick; only a new snap says something again
        // The swatch row names its chosen metal above itself; a circle tells you it is
        // warm and only the words tell you it is 18K. Kept in step here rather than in
        // syncVariant, because it follows the CONTROL rather than the resolved variant —
        // it should update even when the combination has no variant behind it.
        const pos = control.dataset.optionPosition;
        const label = section.querySelector('[data-djh-option-chosen="' + pos + '"]');
        if (label) label.textContent = optionValue(control);
        control.querySelectorAll('.djh-product__swatch').forEach((sw) => {
          sw.classList.toggle('is-selected', sw.querySelector('input').checked);
        });
        // Passed through so the resolver knows which axis to honour when the combination
        // does not exist. Without it a dead end is all it can report.
        syncFromOptionSelects(control);
      });
    });

    // Delegated (not per-element) so it keeps working after renderDynamicThumbs()
    // replaces the thumbnail strip's contents on variant change.
    if (galleryContainer) {
      // ENTER AND SPACE, which a native <button> would have given for free.
      // These thumbnails carry role="button" rather than being buttons (the reason is
      // in the comment on the markup), and role alone changes what a screen reader
      // ANNOUNCES without changing what the keyboard DOES. Without this the gallery
      // is announced as operable and is not — which is worse than the silence it
      // replaced. Space is preventDefault'd so the page does not scroll under it.
      galleryContainer.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
        const thumb = event.target.closest('[data-djh-thumb]');
        if (!thumb) return;
        event.preventDefault();
        thumb.click();
      });

      galleryContainer.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-djh-thumb]');
        if (!thumb || !mainImage || !thumb.dataset.fullSrc) return;
        mainImage.src = thumb.dataset.fullSrc;
        mainImage.srcset = '';
        galleryContainer.querySelectorAll('[data-djh-thumb]').forEach((t) => {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    }

    const checked = form.querySelector('input[name="id"]:checked');
    if (checked) {
      syncVariant(checked.value);
    } else if (variantIdInput && variantIdInput.value) {
      syncVariant(variantIdInput.value);
    } else {
      // Neither branch ran, which is the "nothing chosen yet" state on a ring.
      // The delivery line has to say the SPREAD rather than nothing, because
      // "nothing chosen yet" is the state a customer lands in on a 2,023-variant band.
      // One variant's figure standing in for the product is the failure this whole
      // per-variant build exists to avoid.
      paintDelivery(null);
    }
    // D-277: the page arrives offering only what can be made, with its "+$" already written.
    if (optionSelects.length) refreshChoices();

    // Single/default-variant products never call swapImage() above (no picker to
    // trigger it), so the lightbox would otherwise have nothing to show — seed it
    // from the static gallery thumbs (real multi-angle photos in that case), or
    // just the one main image if there's no strip at all.
    if (!currentGalleryImages.length) {
      const staticThumbSrcs = galleryContainer
        ? Array.from(galleryContainer.querySelectorAll('[data-djh-thumb]')).map((t) => t.dataset.fullSrc).filter(Boolean)
        : [];
      currentGalleryImages = staticThumbSrcs.length ? staticThumbSrcs : mainImage && mainImage.src ? [mainImage.src] : [];
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
